import api from './api';

export const solicitudesService = {
    // Obtener todas las solicitudes (admin ve todas, usuario ve solo las suyas)
    getAll: async (params = {}) => {
        try {
            const { skip = 0, limit = 100, estado, search, soloHallazgos } = params;
            let url = `/solicitudes/?skip=${skip}&limit=${limit}`;

            if (estado) url += `&estado=${estado}`;
            if (search) url += `&search=${encodeURIComponent(search)}`;
            if (soloHallazgos) url += `&solo_hallazgos=true`;

            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('Error en getAll solicitudes:', error);
            throw error;
        }
    },

    // Importar solicitudes masivamente desde un archivo Excel
    importarExcel: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post('/solicitudes/import-excel', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    // Descarga el Excel de solicitudes (observaciones) directamente en el navegador
    exportarExcel: async (soloHallazgos = true) => {
        const response = await api.get('/solicitudes/export/excel', {
            params: { solo_hallazgos: soloHallazgos },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'observaciones.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    // Asignar/reasignar manualmente una solicitud (solo administradores)
    asignar: async (id, asignadoAEmail, asignadoANombre = null) => {
        const response = await api.post(`/solicitudes/${id}/asignar`, {
            asignado_a_email: asignadoAEmail,
            asignado_a_nombre: asignadoANombre,
        });
        return response.data;
    },

    // Obtener datos del Kanban (filtrado automáticamente por rol en backend)
    getKanban: async () => {
        try {
            const response = await api.get('/solicitudes/kanban');
            return response.data;
        } catch (error) {
            console.error('Error en getKanban solicitudes:', error);
            throw error;
        }
    },

    // Obtener solicitud por ID
    getById: async (id) => {
        try {
            const response = await api.get(`/solicitudes/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error en getById solicitudes:', error);
            throw error;
        }
    },

    // Crear solicitud
    create: async (solicitudData) => {
        try {
            console.log('Enviando solicitud:', solicitudData);
            const response = await api.post('/solicitudes/', solicitudData);
            return response.data;
        } catch (error) {
            console.error('Error en create solicitudes:', error.response?.data || error);
            throw error;
        }
    },

    // Actualizar solicitud
    update: async (id, solicitudData) => {
        try {
            const response = await api.put(`/solicitudes/${id}`, solicitudData);
            return response.data;
        } catch (error) {
            console.error('Error en update solicitudes:', error);
            throw error;
        }
    },

    // Cambiar estado
    cambiarEstado: async (id, nuevoEstado) => {
        try {
            const response = await api.post(`/solicitudes/${id}/estado?nuevo_estado=${nuevoEstado}`);
            return response.data;
        } catch (error) {
            console.error('Error en cambiarEstado solicitudes:', error);
            throw error;
        }
    },

    // Eliminar solicitud
    delete: async (id) => {
        try {
            const response = await api.delete(`/solicitudes/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error en delete solicitudes:', error);
            throw error;
        }
    },

    // Escanear código de barras/QR para obtener activo
    scanBarcode: async (code) => {
        try {
            const response = await api.get(`/activos/scan?code=${encodeURIComponent(code)}`);
            return response.data;
        } catch (error) {
            console.error('Error en scan barcode:', error);
            throw error;
        }
    }
};